import { SiteContainer, SiteMockSlot } from '../SiteUi';

const STEPS = [
  {
    n: '1',
    title: 'Você envia',
    items: ['Clientes', 'Veículos', 'Produtos'],
    visual: (
      <SiteMockSlot className="h-[8.75rem] justify-start p-0">
        <p className="border-b border-[#d9d4cc] bg-[#f6f5f3] px-3 py-1.5 font-os text-[11px] text-[#5c5852]">
          clientes.xlsx
        </p>
        {['João Pereira', 'Marina Costa', 'Carlos Mello'].map((nome) => (
          <p key={nome} className="border-t border-[#d9d4cc] px-3 py-1.5 text-sm">
            {nome}
          </p>
        ))}
      </SiteMockSlot>
    ),
  },
  {
    n: '2',
    title: 'A gente prepara',
    items: ['Importação', 'Fiscal', 'WhatsApp', 'Usuários'],
    visual: (
      <SiteMockSlot className="h-[8.75rem]">
        <div className="space-y-2">
          {[
            ['Importação', 'conferida'],
            ['NFC-e', 'conectada'],
            ['WhatsApp', 'ativo'],
          ].map(([label, status]) => (
            <div key={label} className="flex items-center justify-between">
              <span>{label}</span>
              <span className="text-[11px] font-semibold text-[#1f6b43]">{status}</span>
            </div>
          ))}
        </div>
      </SiteMockSlot>
    ),
  },
  {
    n: '3',
    title: 'Sua equipe começa',
    items: ['Primeiro atendimento no AgilizaOS'],
    visual: (
      <SiteMockSlot className="h-[8.75rem]">
        <div className="flex items-center justify-between">
          <span className="font-os">OS-0001</span>
          <span className="rounded bg-[#fff4ea] px-1.5 py-0.5 text-[11px] font-semibold text-[#b15a10]">Aberta</span>
        </div>
        <p className="mt-2 text-[#5c5852]">primeiro dia · Centro</p>
      </SiteMockSlot>
    ),
  },
];

export function SiteImplantacao() {
  return (
    <section className="py-20 sm:py-28">
      <SiteContainer>
        <h2 className="font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          Você não começa do zero.
        </h2>
        <div className="mt-12 grid items-stretch gap-8 md:grid-cols-3">
          {STEPS.map((step) => (
            <article key={step.n} className="flex flex-col">
              {step.visual}
              <p className="mt-5 font-os text-xs tracking-[0.2em] text-[#f5821f]">{step.n}</p>
              <h3 className="mt-2 font-display text-2xl font-semibold">{step.title}</h3>
              <ul className="mt-3 min-h-[5.5rem] space-y-1 text-sm text-[#5c5852]">
                {step.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
        <p className="mt-12 max-w-[48ch] text-lg leading-relaxed text-[#16181d]">
          Você não compra o sistema e recebe um login. A gente acompanha a implantação.
        </p>
      </SiteContainer>
    </section>
  );
}
